module.exports = __webpack_public_path__ + "static/media/pic3.d6d97c87.jpg";